var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailtwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter-svgrepo-com_2_",
    "data-name": "twitter-svgrepo-com (2)",
    transform: "translate(143 -145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34437",
    "data-name": "Path 34437",
    d: "M-131,145a12,12,0,0,0-12,12,12,12,0,0,0,12,12,12,12,0,0,0,12-12A12,12,0,0,0-131,145Zm7.491,19.486a10.478,10.478,0,0,1-3.366,2.269,10.493,10.493,0,0,1-4.125.83,10.611,10.611,0,0,1-4.125-.83,10.579,10.579,0,0,1-3.366-2.269,10.479,10.479,0,0,1-2.269-3.366,10.492,10.492,0,0,1-.834-4.12,10.612,10.612,0,0,1,.83-4.125,10.58,10.58,0,0,1,2.269-3.366,10.641,10.641,0,0,1,3.37-2.273,10.612,10.612,0,0,1,4.125-.83,10.612,10.612,0,0,1,4.125.83,10.58,10.58,0,0,1,3.366,2.269,10.479,10.479,0,0,1,2.269,3.366,10.494,10.494,0,0,1,.83,4.125,10.611,10.611,0,0,1-.83,4.125A10.579,10.579,0,0,1-123.509,164.486Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34438",
    "data-name": "Path 34438",
    d: "M-3.314,309.478a5.026,5.026,0,0,1-1.566.6,2.469,2.469,0,0,0-1.8-.778,2.469,2.469,0,0,0-2.466,2.466,2.253,2.253,0,0,0,.066.563,6.986,6.986,0,0,1-5.081-2.578,2.472,2.472,0,0,0-.333,1.242,2.475,2.475,0,0,0,1.1,2.053,2.5,2.5,0,0,1-1.116-.309v.028a2.465,2.465,0,0,0,1.978,2.419,2.485,2.485,0,0,1-.652.089,2.512,2.512,0,0,1-.464-.042,2.464,2.464,0,0,0,2.3,1.711A4.949,4.949,0,0,1-14.409,318a4.982,4.982,0,0,1-.591-.033,6.985,6.985,0,0,0,3.778,1.106A6.969,6.969,0,0,0-4.2,312.052c0-.108,0-.216,0-.319a4.981,4.981,0,0,0,1.228-1.28,4.948,4.948,0,0,1-1.416.389A2.453,2.453,0,0,0-3.314,309.478Z",
    transform: "translate(-122 -156.598)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailtwitter);
export default __webpack_public_path__ + "static/media/emailtwitter.e7d59c4195742ceab9ff245339105d76.svg";
export { ForwardRef as ReactComponent };